<template>
  <div>
    <web-header :searchStatus="$route.query.moduleId"></web-header>
    <miniCrumb location="新闻 > 新闻详情"></miniCrumb>
    <div class="conent" v-loading="loading">
      <el-row>
        <el-col :span="18">
          <div class="LEFT">
            <h1>{{info.title}}</h1>
            <div class="content">
              <div class="LeftTool">
                <!-- <div data-reactroot class="left-stick-wp" style="top: 0px;">
                  <div class="year through">
                    <span>{{getDate(info.publish_time,'Y')}}</span>
                  </div>
                  <div class="md">
                    {{getDate(info.publish_time,'M')}}
                    /
                    {{getDate(info.publish_time,'D')}}
                  </div>
                  <div class="time">{{getDate(info.publish_time,'T')}}</div>

                  <div class="comment-count-title through">
                    <span>浏览量</span>
                  </div>

                  <div class="text">
                    <i id="cmtNum">{{info.page_view}}</i>
                  </div>

                  <div class="share-title through" data-bossirs="share">
                    <span>分享</span>
                  </div>
                  <div class="share" data-bosszone="share">
                    <a class="wxWrap">
                      <i class="iconfont icon-icon-"></i>
                    </a>
                    <a>
                      <i class="iconfont icon-qq1"></i>
                    </a>
                    <a>
                      <i class="iconfont icon-qqkongjian"></i>
                    </a>
                    <a>
                      <i class="iconfont icon-weibo1"></i>
                    </a>
                  </div>
                </div>-->
              </div>

              <div class="content-article">
                <template v-if="info.type == 2">
                  <!-- <el-carousel :interval="4000" arrow="always" :autoplay="false" height="450px">
                    <el-carousel-item v-for="(item, index) in info.subsidiary_files" :key="index">
                      <img :src="item.file_detail.path" style="max-width:100%" />
                    </el-carousel-item>
                  </el-carousel>-->
                  <swiper :options="swiperOption">
                    <swiper-slide v-for="(item,index) in info.subsidiary_files" :key="index">
                      <img :src="item.file_detail.path" alt />
                    </swiper-slide>
                    <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
                    <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
                  </swiper>
                </template>

                <div
                  class="tt-video-box"
                  v-if="info.type == 3"
                  v-html="info.subsidiary_files[0].code"
                ></div>
                <div v-html="info.content" style="margin-top:20px;"></div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="RIGHT">
            <div class="right-bar">
              <div class="om-bar">
                <div class="bar-tit">
                  <h2 class="fl">推荐新闻</h2>
                </div>

                <div class="bar-con">
                  <WtDataList
                    v-model="data.list"
                    :isPage="false"
                    :url="$url.news.list"
                    :pageSize="3"
                    :search="search"
                  >
                    <div slot="list">
                      <div class="item" v-for="(item,index) in data.list" :key="index">
                        <template v-if="item.cover_photo_text.length==0">
                          <div class="txt" style="width:250px">
                            <router-link
                              :to="{ name: 'newsInfo',query: { id: item.id }}"
                            >{{item.title}}</router-link>
                          </div>
                        </template>
                        <template v-else>
                          <div class="pic">
                            <router-link :to="{ name: 'newsInfo',query: { id: item.id }}">
                              <img :src="item.cover_photo_text[0].path" />
                            </router-link>
                          </div>
                          <div class="txt">
                            <router-link
                              :to="{ name: 'newsInfo',query: { id: item.id }}"
                            >{{item.title}}</router-link>
                          </div>
                        </template>
                        <div
                          class="time"
                        >{{getDate(item.publish_time,'Y')}}- {{getDate(item.publish_time,'M')}}-{{getDate(item.publish_time,'D')}}</div>
                      </div>
                    </div>
                  </WtDataList>
                </div>
              </div>
            </div>
          </div>

          <div class="RIGHT">
            <div class="right-bar">
              <div class="cms-bar">
                <div class="bar-tit">
                  <h2 class="fl">相关活动</h2>
                </div>

                <div class="bar-con">
                  <WtDataList
                    v-model="data.activityList"
                    :isPage="false"
                    :url="$url.activity.list"
                    :pageSize="3"
                    :search="search"
                  >
                    <div slot="list">
                      <div class="item" v-for="(item,index) in data.activityList" :key="index">
                        <router-link :to="{ name: 'activityInfo',query: { id: item.id }}">
                          <div class="pic">
                            <img :src="item.cover_photo_text[0].path" />
                          </div>
                        </router-link>
                        <router-link :to="{ name: 'activityInfo',query: { id: item.id }}">
                          <div class="txt">{{item.name}}</div>
                        </router-link>
                      </div>
                    </div>
                  </WtDataList>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <WtFooter></WtFooter>
  </div>
</template>
<script>
import webHeader from "../Public/header";
import miniCrumb from "../Public/miniCrumb";
import { swiper, swiperSlide } from "vue-awesome-swiper";
require("swiper/dist/css/swiper.css");
export default {
  components: {
    webHeader,
    miniCrumb,
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        spaceBetween: 30,
        effect: "fade",
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      loading: true,
      info: {},
      images: [],
      dialogTableVisible: true,
      hover: false,
      data: {},
      search: {
        type: null
      },
      activityList: [
        {
          id: 1,
          title: "顺丰公益基金会2015年夏令营志愿者招募啦！",
          time: "下午 13:45"
        },
        {
          id: 2,
          title: "邵阳县二中举行2018年顺丰莲花助学开班仪式",
          time: "下午 13:45"
        },
        {
          id: 3,
          title: "邵阳县二中举行2018年顺丰莲花助学开班仪式",
          time: "下午 13:45"
        }
      ],
      liData: ["liBg1", "liBg2", "liBg3"],
      applyInfo: {
        list: [],
        total: 0
      }
    };
  },
  methods: {
    scrollBehavior() {
      document.getElementById("dt_list_main").scrollIntoView();
    },
    getDate(date, format = "M") {
      date += "";
      switch (format) {
        case "Y": {
          return date.substring(0, 4);
          break;
        }
        case "M": {
          return date.substring(5, 7);
          break;
        }
        case "D": {
          return date.substring(8, 10);
          break;
        }
        case "T": {
          return date.substring(11, 16);
          break;
        }
      }
    },
    getClass(index) {
      let j = parseInt(index / 3);
      if (j % 2 == 0) {
        // 再通过取模来设置每隔3行显示不同的两种颜色
        return "liBg2";
      } else {
        //return "liBg3"
        return "liBg2";
      }
    },
    handleScroll() {
      if (this.getScrollBottomHeight() <= -650) {
        this.hover = true;
      } else {
        this.hover = false;
      }
    },
    //滚动条到底部的距离
    getScrollBottomHeight() {
      return (
        this.getPageHeight() - this.getScrollTop() - this.getWindowHeight()
      );
    },
    //页面高度
    getPageHeight() {
      return document.querySelector("html").scrollHeight;
    },
    //滚动条顶 高度
    getScrollTop() {
      var scrollTop = 0,
        bodyScrollTop = 0,
        documentScrollTop = 0;
      if (document.body) {
        bodyScrollTop = document.body.scrollTop;
      }
      if (document.documentElement) {
        documentScrollTop = document.documentElement.scrollTop;
      }
      scrollTop =
        bodyScrollTop - documentScrollTop > 0
          ? bodyScrollTop
          : documentScrollTop;
      return scrollTop;
    },
    getWindowHeight() {
      var windowHeight = 0;
      if (document.compatMode == "CSS1Compat") {
        windowHeight = document.documentElement.clientHeight;
      } else {
        windowHeight = document.body.clientHeight;
      }
      return windowHeight;
    },
    init() {
      this.loading = true;
      let id = this.$route.query.id;
      this.$db.get(this.$url.news.url + "/" + id).then(resp => {
        this.info = resp.data;
        this.loading = false;
        if (resp.data.type == 2) {
          let that = this;
          resp.data.subsidiary_files.forEach(element => {
            that.images.push(element.file_detail.path);
          });
        }
      });
    }
  },
  mounted() {
    this.init();
  },
  //页面销毁，页面销毁时移除监听事件，否则其他页面也会自动进入scroll的监听中
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    $route(to, from) {
      this.init();
    }
  }
};
</script>

<style scoped>
.conent {
  width: 1240px;
  margin: 0 auto 40px;
}
a {
  color: #333;
  text-decoration: none;
}
.LEFT {
  width: 890px;
  float: left;
}
.LEFT h1 {
  font-size: 36px;
  line-height: 1.5;
  margin-bottom: 25px;
  color: #333;
  text-align: center;
  margin-top: 8px;
}
.RIGHT {
  float: right;
  width: 300px;
  padding-top: 24px;
}

.content {
  width: 890px;
}
.LeftTool {
  width: 80px;
  padding-right: 30px;
  margin-right: 30px;
  text-align: center;
  float: left;
  font-size: 12px;
  color: gray;
}
.left-stick-wp {
  width: 80px;
  -webkit-transition: all 0.5s;
  -o-transition: all 0.5s;
  transition: all 0.5s;
}

.LeftTool .left-stick-wp {
  position: relative;
}

.LeftTool .through {
  position: relative;
}

.LeftTool .md,
.LeftTool .year {
  color: #000;
  font-family: Politica;
}
.LeftTool .year {
  font-size: 20px;
}
.LeftTool .through span {
  display: inline-block;
  background: #fff;
  padding: 0 5px;
}
.LeftTool .through:after {
  content: "";
  display: block;
  width: 100%;
  height: 1px;
  background: #e8e8e8;
  position: absolute;
  top: 50%;
  left: 0;
  z-index: -1;
}
.LeftTool .md {
  font-size: 20px;
  line-height: 1.2;
}
.LeftTool .time {
  font-size: 16px;
  color: #000;
  font-family: Politica;
  margin-bottom: 25px;
}
.LeftTool .share-title {
  margin-top: 100px;
  margin-bottom: 18px;
}
.LeftTool .through span {
  display: inline-block;
  background: #fff;
  padding: 0 5px;
}
.share .wxWrap {
  position: relative;
}

.share > a {
  width: 40px;
  height: 40px;
  margin: 10px auto 0;
  border-radius: 50%;
  display: block;
  cursor: pointer;
  line-height: 40px;
  color: #fff !important;
  -webkit-transition: all 0.5s;
  -o-transition: all 0.5s;
  transition: all 0.5s;
  position: relative;
  background: #ccc;
}
.content-article {
  /* width: 730px; */
  /* float: right; */
  font-size: 16px;
}

.LeftTool .text {
  display: inline-block;
  font-size: 20px;
  line-height: 1;
  top: -15px;
  color: #ff2f2f;
  text-align: center;
  right: -10px;
  font-family: constani;
  width: 52px;
}
.LeftTool .comment-count .text i {
  background: #fff;
  padding: 3px 5px;
  display: inline-block;
}

.LeftTool .comment-count-title {
  margin: 54px auto 15px;
}
.right-bar {
  float: right;
  width: 100%;
}
.right-bar .bar-tit {
  padding: 20px 0 30px;
}
.right-bar .bar-tit h2 {
  position: relative;
  height: 17px;
  line-height: 16px;
  font-size: 20px;
  font-weight: 700;
}

.fl {
  float: left;
}
.right-bar .bar-tit .change-btn {
  font-size: 14px;
  line-height: 17px;
  cursor: pointer;
}

.fr {
  float: right;
}
.right-bar .bar-tit .change-btn .icon-shuaxin {
  display: inline-block;
  width: 14px;
  height: 14px;
  line-height: 17px;
  margin: -3px 3px 0 0;
  -webkit-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
}

.iconfont {
  font-family: iconfont !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.iconfont {
  vertical-align: middle;
}
.cms-bar .bar-con .item {
  position: relative;
  overflow: hidden;
}
.cms-bar .bar-con .item .pic {
  position: relative;
  height: 140px;
  overflow: hidden;
}
.cms-bar .bar-con .item .pic img {
  min-height: 140px;
}

.bar-con .item .pic img {
  position: relative;
  width: 100%;
  font-size: 14px;
  display: inline-block;
  color: #999;
}
.cms-bar .bar-con .item .txt {
  position: relative;
  padding: 8px 0 20px;
  font-size: 14px;
  line-height: 20px;
}

.om-bar .item {
  position: relative;
  padding: 10px 0;
  font-size: 14px;
  min-height: 80px;
}
.om-bar .item .pic {
  float: left;
  width: 120px;
  height: 80px;
  margin-right: 10px;
  overflow: hidden;
  border-radius: 4px;
}
.om-bar .item .pic img {
  width: 120px;
}
.bar-con .item .pic{
  border-radius: 4px;
}
.bar-con .item .pic img {
  position: relative;
  min-height: 80px;
}
.om-bar .item .txt {
  float: left;
  width: 130px;
  height: 60px;
  overflow: hidden;
  line-height: 20px;
}
.om-bar .item .time {
  padding-left: 130px;
  color: #c4c4c4;
}
</style>
<style>
iframe {
  width: 100%;
  min-height: 400px;
}
img {
  max-width: 100%;
}
table {
  max-width: 60vw;
}
</style>


// WEBPACK FOOTER //
// src/view/News/info.vue